import { useCallback } from 'react';
import { saveLastWatchedChannel } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';
import { useLogger } from '@/shared/hooks/useLogger';

interface SaveLastWatchedChannelParams {
    contentId: string;
}

export const useSaveLastWatchedChannel = () => {
    const graphqlClient = useGraphqlClient();
    const logger = useLogger();

    return useCallback(
        async ({ contentId }: SaveLastWatchedChannelParams) => {
            try {
                await graphqlClient.fetch({
                    operation: saveLastWatchedChannel,
                    variables: { contentId },
                });
            } catch (error) {
                logger.error({ error }, 'Failed to save last watched channel');
            }
        },
        [graphqlClient, logger]
    );
};
